import React from "react";
import "./HomeDescription.css";

export default function HomeDescription() {
  return (
    <>
      <div className="HomeDescription">
        <span className="homeDescriptionText">
          横浜市の音楽教室／二俣川／三ツ境／チェロ／声楽／出張レッスン／出張演奏
        </span>
      </div>
    </>
  );
}
